import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {Flex, Text} from '@chakra-ui/react'
import useOcapiSite from '../../hooks/useOcapiSite'
import ApplePay from '../apple-pay'
import useAdyenCheckout from '../../hooks/use-adyen-checkout'
import useApplePay from '../../hooks/use-apple-pay'

const APPLEPAY_METHOD = 'applepay'

const ExpressCheckout = ({containerProps, pageType = 'cart'}) => {
    const {cartEnabledExpressPayments, checkoutEnabledExpressPayments} = useOcapiSite()
    const isApplePayEnabled = useMemo(
        () =>
            pageType === 'cart'
                ? Boolean(cartEnabledExpressPayments?.includes(APPLEPAY_METHOD))
                : Boolean(checkoutEnabledExpressPayments?.includes(APPLEPAY_METHOD)),
        [cartEnabledExpressPayments, checkoutEnabledExpressPayments, pageType]
    )

    // check for active applePay
    const {checkout} = useAdyenCheckout({
        enabled: isApplePayEnabled,
        requiredMethod: APPLEPAY_METHOD
    })
    const {applePay} = useApplePay({checkout, enabled: isApplePayEnabled})

    // if no applePay is available, return null
    if (!applePay) {
        return null
    }

    return (
        <Flex
            flexDirection="column"
            alignItems="stretch"
            gap={2}
            paddingTop={pageType === 'cart' ? 0 : 4}
            {...containerProps}
        >
            {pageType === 'cart' && (
                <Text textStyle="Semi Bold Small">
                    <FormattedMessage
                        defaultMessage="Express Checkout"
                        id="express-checkout.heading.express-checkout"
                    />
                </Text>
            )}
            <ApplePay basketAmount={checkout?.options?.amount?.value} />
        </Flex>
    )
}

ExpressCheckout.propTypes = {
    pageType: PropTypes.string,
    containerProps: PropTypes.object
}

export default ExpressCheckout
